// Display browser-local time; exchange UTC Unix timestamps (seconds) with the API.
export function formatGymDate(timestamp) {
  if (timestamp === null || timestamp === undefined) return '';
  const date = new Date(Number(timestamp) * 1000);
  if (!Number.isFinite(date.getTime())) throw new RangeError('Invalid timestamp');
  const pad = value => String(value).padStart(2, '0');
  return `${String(date.getFullYear()).padStart(4, '0')}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function parseGymDate(value) {
  if (!value) return null;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value)) return NaN;
  const normalized = value.length === 16 ? `${value}:00` : value;
  const timestamp = Date.parse(normalized) / 1000;
  // Reject impossible dates and local times skipped during daylight-saving changes.
  return Number.isFinite(timestamp) && formatGymDate(timestamp) === normalized ? timestamp : NaN;
}

export function maintenanceStatus(start, end, now) {
  if (start == null || end == null || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
    return 'Не запланировано';
  }
  if (now < start) return 'Запланировано';
  return now < end ? 'Идёт ТО' : 'Завершено';
}
